import React, { useState, useMemo } from 'react'; // eslint-disable-line

/* Redux */
import { useDispatch, useSelector } from 'react-redux';
import { loginActions } from '../../../store/login/actions';
import { RootState } from '../../../store';
import { isSignupCredentialsError } from '../../../sagas/login/authErrors';

const EMAIL_REGEX = /^[\w+-.]+@([\w-]+\.)+[\w-]{2,4}$/; // eslint-disable-line
export const useSignUpForm = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [checked, setChecked] = useState<boolean>(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState<boolean>(false);
  const [submittedEmail, setSubmittedEmail] = useState<string>('');
  const dispatcher = useDispatch();
  const isLoading = useSelector((state: RootState) => state.login.isLoading);
  const errorType = useSelector((state: RootState) => state.login.errorType);

  const isSignUpBottomDisabled: boolean = useMemo(() => {
    return (
      !EMAIL_REGEX.test(email) || password.length < 6 || !checked || isLoading
    );
  }, [email, password, checked, isLoading]);

  const showCredentialsError =
    isSignupCredentialsError(errorType) && email === submittedEmail;

  const handleSignUpSubmit = (e: any) => {
    e.preventDefault();
    if (isLoading) return;

    setSubmittedEmail(email);
    dispatcher(loginActions.signupRequestAction(email, password));
  };

  return {
    states: {
      email,
      setEmail,
      password,
      setPassword,
      checked,
      setChecked,
      isLoginModalOpen,
      setIsLoginModalOpen,
    },
    isSignUpBottomDisabled,
    showCredentialsError,
    handleSignUpSubmit,
  };
};
